import { action, autorun, observable } from 'mobx';
import { isFirefox } from 'react-device-detect';


import AdStore from 'stores/AdStore';
import ProfileStore from 'stores/ProfileStore';
import trackingService from 'services/UITrackingService';

import {
  AD_ZONE_IDS,
  BASE_AD_URL,
  TRIGGER_DELAY,
} from './constants';


class CompanionAdsService {
  currentAdTimeout = null;
  adShown = false;

  constructor() {
    autorun(this.#syncAdService);
  }

  @observable isAdVisible = false;

  @action showAd = () => this.isAdVisible = true;
  @action hideAd = () => this.isAdVisible = false;

  canShowAds = () => {
    const { canShowAds } = AdStore;
    const { isUserInPaidShow } = ProfileStore;

    if (
      isFirefox ||
      !canShowAds ||
      isUserInPaidShow
    ) {
      return false;
    }

    return true;
  };

  getTrackingPayload = (details) => {
    const payload = {
      ...details,
      adType: 'companion',
    };

    return payload;
  };

  handleContainerEvents = (container) => {
    trackingService.emit('adLoaded', this.getTrackingPayload({ container }));
  };

  containerLoaded = (container) => {
    this.handleContainerEvents(container);
  };

  closeCurrentAd = (userAction = true) => {
    if (this.adShown) {
      trackingService.emit('adClose', this.getTrackingPayload({ userAction }));
    }
  };

  triggerAd = () => {
    this.cancelExistingAd(false);

    if (!this.canShowAds()) {
      return;
    }

    this.currentAdTimeout = setTimeout(() => {
      this.adShown = true;
      this.showAd();
    }, TRIGGER_DELAY);
  };

  cancelExistingAd = (userAction = true) => {
    clearTimeout(this.currentAdTimeout);
    this.closeCurrentAd(userAction);
    this.hideAd();

    this.adShown = false;
  };

  clickAd = () => {
    trackingService.emit('adClick', this.getTrackingPayload());
  };

  getAdDetails = () => {
    const { streamingSource } = ProfileStore;
    if (!streamingSource) {
      return null;
    }

    const { genderType: genderPreference } = AdStore;
    const id = AD_ZONE_IDS[genderPreference];

    const url = new URL(BASE_AD_URL);
    url.searchParams.set('idzone', id);
    url.searchParams.set('output', 'noscript');
    url.searchParams.set('type', '300x100');

    return { id, url };
  };

  #syncAdService = () => {
    const { canShowAds } = AdStore;

    if (!canShowAds && !this.canShowAds()) {
      clearTimeout(this.currentAdTimeout);
      this.hideAd();
      this.adShown = false;
    }
  };
}

export default new CompanionAdsService();
